
export const isAudio = (file: File) => file.type.indexOf('audio') > -1;


export const range = (min: number, max: number) => Array.from(
  new Array(max - min + 1),
  (v, i) => i + min,
);

interface FileReadAsType {
  ArrayBuffer: ArrayBuffer;
  DataURL: string;
}

export const readFile = <Type extends keyof FileReadAsType>(
  file: Blob,
  dataType: Type,
) => new Promise<FileReadAsType[Type]>((resolve, reject) => {
    const reader = new FileReader();
    (reader as any)[`readAs${dataType}`](file);
    reader.onload = () => resolve(reader.result as any);
    reader.onerror = (err) => reject(err);
  });


export const readArrayBuffer = (file: Blob) => readFile(file, 'ArrayBuffer');

export const readDataURL = (file: Blob) => readFile(file, 'DataURL');

export const readBlobURL = (file: Blob) => URL.createObjectURL(file);

export const download = (url: string, name: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.click();
};

export const rename = (filename: string, ext: string, stamp?: string) => `${filename.replace(/\.\w+$/, '')}${stamp || ''}.${ext}`;

export const formatSeconds = (seconds: number) => [
  Math.floor(seconds / 60),
  Math.floor(seconds % 60),
  Math.round((seconds % 1) * 100),
];
